//腾讯云rtc客户端
let client_ = null
//本地音视频流
let localStream_ = null
// 用户id
let numberRandom = Number(Math.floor(Math.random() * 10000))

import { CHAT, websocketapp } from '@/common/websocket/index'
import { getUserSig } from '@/api/trtc/config'
import { getSession } from '@/api/common'
import TRTC from 'trtc-js-sdk'
import store from '@/store/index'
/**
 * 获取签名
 */
function _getUserSig() {
  let param = {
    number: numberRandom,
  }
  getUserSig(param).then(res => {
    if (res.state === 0) {
      let userSig = res.value.userSig
      let sdkAppId = Number(res.value.sdkAppId)
      createClient(userSig, sdkAppId)
    }
  })
}
/**
 * 创建客户端
 */
function createClient(userSig, sdkAppId) {
  client_ = TRTC.createClient({
    mode: 'rtc',
    sdkAppId: sdkAppId,
    // userId: getSession('userId')  + Math.floor(Math.random() * 10000),
    userId: getSession('userId') + '_' + numberRandom,
    userSig: userSig,
    useStringRoomId: true,
  })
  /**
   * 远端流通过监听
   */
  client_.on('stream-added', event => {
    const remoteStream = event.stream
    console.log('远端流增加: ' + remoteStream.getId())
    //订阅远端流
    client_.subscribe(remoteStream)
  })
  client_.on('stream-subscribed', event => {
    const remoteStream = event.stream
    console.log(remoteStream)
    console.log('远端流订阅成功：' + remoteStream.getId())
    // 音频流放置walkieDom标签
    remoteStream.play('walkieDiv')
  })
}
/**
 * 创建本地流
 */
function createStream() {
  console.log('创建本地流')
  localStream_ = TRTC.createStream({
    userId: getSession('userId') + '_' + numberRandom,
    audio: true,
    video: false,
  })
  localStreamInitialize()
}

/**
 * 初始化本地音视频流
 */
function localStreamInitialize() {
  localStream_
    .initialize()
    .then(() => {
      console.log('初始化本地流成功')
      localStreamPublish()
    })
    .catch(error => {
      console.error('初始化本地流失败 ' + error)
    })
}

/**
 * 发布本地流
 */
function localStreamPublish() {
  client_
    .publish(localStream_)
    .then(() => {
      console.log('本地流发布成功')
    })
    .catch(error => {
      console.error('本地流发布失败 ' + error)
    })
}

/**
 * 退出房间
 */
function closeResetMeet() {
  console.log('退房------------')
  try {
    store.commit('openWaike', false)
    // 取消发布本地流
    if (typeof client_.leave === 'function') {
      client_
        .leave()
        .then(() => {
          // 退房成功，可再次调用client.join重新进房开启新的通话。
          console.log('退房成功 ')
        })
        .catch(error => {
          console.error('退房失败 ' + error)
        })
    }
  } catch (error) {
    console.log(error)
  }
}

/**
 * 加入房间
 * @param {String} roomId 房间id
 */
function joinRoomTrtc(roomId) {
  setTimeout(() => {
    client_
      .join({ roomId })
      .then(() => {
        console.log('进房成功')
        createStream()
      })
      .catch(error => {
        console.error('进房失败 ' + error)
      })
  }, 500)
}

/**
 * 生成随机数字符串
 * @param {String} roomId 房间id
 */
function randomNumstr(length) {
  if (typeof length != 'number') {
    length = 4
  }
  var numStr = Math.floor(Math.random() * 10) + 1 + ''
  for (var i = 1; i < length; i++) {
    numStr += Math.floor(Math.random() * 10)
  }
  return numStr
}

/**
 * 加入对讲房间
 * @param {*} helmetList 进房用户列表
 * @param {*} roomId 进房id
 */
function helmetJoinWaike(helmetList, roomId) {
  let preNum = randomNumstr(4)
  let nextNum = new Date().getTime() + ''
  nextNum = nextNum.substr(nextNum.length - 4)
  roomId = preNum + nextNum
  var sendMsg = {
    content: {
      cmd: 'GROUP_CHAT',
      code: '000',
      params: {
        // 发起对讲时时用helmetlist
        helmetList: helmetList,
        roomId: roomId,
        fromUser: getSession('username'),
      },
    },
    header: {
      from: getSession('userId'),
      to: 'SYS',
      requireResponse: false,
    },
  }
  CHAT.chat(websocketapp.WALKIE, '', sendMsg)
  store.commit('openWaike', true)
}

/**
 * 退出全部房间
 * @param {*} currenData 当前房间用户数据
 * @param {*} isEnterRoom 是否接通
 */
function exitRemoteRoom(currenData, isEnterRoom) {
  store.commit('openWaike', false)
  // 处理除去本身列表
  let helmetList = []
  let userList = currenData.userList
  let userId = getSession('userId')
  for (var i = 0; i < userList.length; i++) {
    if (userId !== userList[i].userId) {
      helmetList.push(userList[i].helmetId)
    }
  }
  // (1是拨通后挂断，2是未拨通挂断)
  let hangUp = ''
  if (isEnterRoom) {
    hangUp = '1'
  } else {
    hangUp = '2'
  }
  var sendMsg = {
    content: {
      cmd: 'GROUP_CHAT',
      code: '000',
      params: {
        // 挂断对讲时用to
        to: helmetList,
        hangUp: hangUp,
      },
    },
    header: {
      from: getSession('userId'),
      to: 'SYS',
      requireResponse: false,
    },
  }
  CHAT.chat(websocketapp.WALKIE, '', sendMsg)
}

/**
 * 业务相关
 */

export { helmetJoinWaike, _getUserSig, joinRoomTrtc, exitRemoteRoom, closeResetMeet }
